import { v4 as uuid } from 'uuid';

import { splitMarkdownAndComments } from 'src/utils/voicebox/parsing/splitMarkdownAndComments';
import { VoiceboxTurtleResponseMessage } from 'src/utils/voicebox/types';

export const createTurtleResponseMessage = ({
  content,
  requestMessageId,
  hidden,
}: {
  content: string;
  requestMessageId: string;
  hidden?: boolean;
}): VoiceboxTurtleResponseMessage => {
  const { before, code, after } = splitMarkdownAndComments(content);
  return {
    role: 'assistant',
    isTurtleResponse: true,
    requestMessageId,
    content,
    after,
    before,
    code,
    id: uuid(),
    hidden,
  };
};
